import React, {useState, useEffect, useRef} from 'react'
import DefaultPage from "./pages/DefaultPage";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import axios from 'axios'
import './App.css';
import PrimeReact from 'primereact/api';
import { Button } from 'primereact/button';

PrimeReact.ripple = true;

const App = () => {

	const [counter, setCounter] = useState('')

	const flag = useRef(true)

	useEffect(
		() => {
			if (flag.current) {
				flag.current = false
				const counterValue = localStorage.getItem('counter')
				if (counterValue) {
					axios.get('https://rapi.gvasilopoulos.xyz/read/')
						.then(res => {
							setCounter(res.data.data)
							localStorage.setItem('counter', res.data.data)
						})
						.catch(err => {
							console.log('Counter API unavailable')
							setCounter(counterValue)
						})
				} else {
					axios.get('https://rapi.gvasilopoulos.xyz/write/')
						.then(res => {
							setCounter(res.data.data)
							localStorage.setItem('counter', res.data.data)
						})
						.catch(err => {
							console.log('Counter API unavailable')
							setCounter('--')
						})
				}
			}
		},[]
	)

	return (
		<div className="app">
			{/*<Button id="toggle" label={toggle ? "Boring Version" : "Fun Version"} onClick={() => setToggle(!toggle)}/>*/}
			<Button id="counter" label={`Visitors: ${counter}`}/>
			{/*{toggle ? <FunPage/> : <DefaultPage/>}*/}
			<DefaultPage/>
		</div>
	);
}

export default App;
